import { render, staticRenderFns } from "./AssetViewer.vue?vue&type=template&id=158ee248&scoped=true&"
import script from "./AssetViewer.vue?vue&type=script&lang=js&"
export * from "./AssetViewer.vue?vue&type=script&lang=js&"
import style0 from "./AssetViewer.vue?vue&type=style&index=0&id=158ee248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158ee248",
  null
  
)

export default component.exports